import { PayloadAction, createSlice } from "@reduxjs/toolkit";
// import { ReduxStore } from "../../../../store";
import { UserModel } from "../../../types/models";
import { LogonResponse } from "../../../types/responses";
import { LoginCredentialParam } from "../../../types/params";
import { UserRoleModel } from "../../../types/models/userRole.model";
import { PssStoreSlices } from "../../../configs/_pss.store.slice";

export interface PssAuthStoreSlice {
  id: string | null;
  user: UserModel | null;
  accessToken: string | null;
  refreshToken: string | null;
  credential: LoginCredentialParam;
  role: UserRoleModel[];
}

const initialState: PssAuthStoreSlice = {
  id: null,
  user: null,
  accessToken: null,
  refreshToken: null,
  role: [],
  credential: {
    email: null,
    password: null,
  },
};

const pssAuthSlice = createSlice({
  name: "pssAuth",
  initialState,
  reducers: {
    storePssSetUserCredential: (
      state,
      action: PayloadAction<LoginCredentialParam>,
    ) => {
      state.credential = action.payload;
    },
    storePssClearUserCredential: (state, _action) => {
      state.credential = {
        email: null,
        password: null,
      };
    },
    storePssSetCredential: (state, action: PayloadAction<LogonResponse>) => {
      const { id, user, accessToken, refreshToken, role } = action.payload;
      state.id = id;
      state.user = user;
      state.accessToken = accessToken;
      state.refreshToken = refreshToken;
      state.role = role ?? [];
      state.credential = {
        email: null,
        password: null,
      };
    },
    storePssClearCredential: (state, _action: PayloadAction<void>) => {
      state.id = null;
      state.user = null;
      state.accessToken = null;
      state.refreshToken = null;
      state.role = [];
      state.credential = {
        email: null,
        password: null,
      };
    },
  },
});

// Actions
export const {
  storePssSetCredential,
  storePssClearCredential,
  storePssSetUserCredential,
  storePssClearUserCredential,
} = pssAuthSlice.actions;

// Selector
export const storePssSelectCurrentUser = (state: PssStoreSlices) =>
  state.pssAuth.user;
export const storePssSelectCredential = (state: PssStoreSlices) =>
  state.pssAuth.credential;
export const storePssSelectAccessToken = (state: PssStoreSlices) =>
  state.pssAuth.accessToken;
export const storePssSelectRefreshToken = (state: PssStoreSlices) =>
  state.pssAuth.refreshToken;
export const storePssSelectCurrentRole = (state: PssStoreSlices) =>
  state.pssAuth.role;
export const storepssSelectCurrentId = (state: PssStoreSlices) =>
  state.pssAuth.id;

// Reducers
export default pssAuthSlice.reducer;
